<script setup>
import { WDialog } from '@alice-health/wonderland-vue'

const emit = defineEmits(['onClose'])

const handleOnClose = event => {
  emit('onClose', event)
}
</script>
<template>
  <WDialog
    dialog-id="dialog"
    opened
    dismiss
    size="large"
    title="Você aceita esse redirecionamento de N1?"
    description="Ao aceitá-lo, você se tornará responsável desse canal e removerá
        automaticamente todos inclusos nesse canal. Caso seja necessário, poderá
        adicioná-los manualmente."
    confirm-label="Aceitar"
    cancel-label="Cancelar"
    icon="icAlertTriangle"
    @w-closed="handleOnClose"
  >
  </WDialog>
</template>

<style lang="scss" scoped />
